import { combineReducers } from 'redux';
import sections from 'redux/modules/sections';
import settings from 'redux/modules/settings';
import form from 'redux/modules/form';
import notify from 'redux/modules/notify';
import pages from 'redux/modules/pages';
import flag from 'redux/modules/flag';
import options from 'redux/modules/options';
import fields from 'redux/modules/fields';
import changedFields from 'redux/modules/changedFields';
import hiddenFields from 'redux/modules/hiddenFields';
import account from 'redux/modules/account';
import promoSettings from 'redux/modules/promoSettings';
import sponsor from 'redux/modules/sponsor';
import partner from 'redux/modules/partner';
import { UPDATE_ALL_FORM_DATA } from 'redux/modules/formData';

const appReducer = combineReducers({
    flag,
    form,
    notify,
    options,
    pages,
    sections,
    settings,
    fields,
    changedFields,
    hiddenFields,
    account,
    promoSettings,
    sponsor,
    partner
});

const rootReducer = (state, action) => {
    if (action.type === UPDATE_ALL_FORM_DATA) {
        return {
            ...state,
            ...action.payload
        };
    }

    return appReducer(state, action);
};

export default rootReducer;
